import React from 'react';
import PropTypes from 'prop-types';
import { AppHeader } from './AppHeader';
import AppFooter from '../application/AppFooter';

export function PublicLayout({ children }) {
  return (
    <>
      <AppHeader />
      {children}
      <AppFooter />
    </>
  );
}

PublicLayout.propTypes = {
  children: PropTypes.node,
};
